import { IAccDoiTuongKhongTinhHocPhi } from "../../../model/respone/category/IAccDoiTuongKhongTinhHocPhi";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eAccDoiTuongKhongTinhHocPhiActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IAccDoiTuongKhongTinhHocPhi[],
  LOAD_ERRR: "",

  SAVE_START: {} as IAccDoiTuongKhongTinhHocPhi,
  SAVE_SUCCESS: {} as IAccDoiTuongKhongTinhHocPhi,
  SAVE_ERROR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERROR: "",

  SHOW_EDIT_MODAL: {} as undefined | IAccDoiTuongKhongTinhHocPhi,
  CLOSE_EDIT_MODAL: undefined,
};
export const eAccDoiTuongKhongTinhHocPhiActionIds = generateActionTypeIds(
  eAccDoiTuongKhongTinhHocPhiActionsObj,
  "DOI_TUONG_KHONG_TINH_HOC_PHI",
);

export type IAccDoiTuongKhongTinhHocPhiActionTypes = IGenericActionType<
  typeof eAccDoiTuongKhongTinhHocPhiActionsObj,
  "DOI_TUONG_KHONG_TINH_HOC_PHI"
>;
